import React, {useEffect, useState} from "react";
import {connect, useDispatch} from "react-redux";
import {Button, Modal} from "react-bootstrap";
import axios from "axios"
// eslint-disable-next-line no-restricted-imports
import {makeStyles} from "@material-ui/core/styles";
import {Checkbox, CircularProgress} from "@material-ui/core";
import RenderIf from "app/components/RenderIf";
import * as ticketRedux from "app/modules/Tickets/_redux/ticketRedux";
import * as authRedux from "app/modules/Auth/_redux/authRedux";
import * as play from "../_redux/PlayRedux";
import {actions} from "app/hoc/Snackbar/snackbarRedux";

const {setSnackbar} = actions;

const useStyles = makeStyles({
    col: {
        "&:nth-child(2n+1)": {
            backgroundColor: "#EFF8FF"
        }
    },
    progresRoot: {
        width: "100%",
        padding: "32px 16px",
    },
    progress: {
        margin: "auto",
        display: "block",
        color: "#e2241b",
    },
})

const {setPrintData} = ticketRedux.actions;
const {getProfile} = authRedux.actions;

const CreateVoidTicket = ({
                              show,
                              onHide,
                              id,
                              onCirculationChoose,
                              isLoading,
                              setIsLoading,
                              setShowBet,
                              setShowPrint
                          }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [circulationGames, setCirculationGames] = useState([]);
    const [columnPrice, setColumnPrice] = useState(1);
    const [error, setError] = useState("")
    const [initialState, setInitialState] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);


    const handleChange = (e, index, option) => {
        let arr = [...initialState];
        arr[index][option] = Boolean(e.target.checked);
        setInitialState(arr);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let allFalseArr = [];
        const group = {
            ticketGames: initialState,
            circulationId: id
        }
        initialState.forEach((gameObj) => {
            let oneChecked = false;
            for (const option in gameObj) {
                if (option === "gameId") continue;
                if (gameObj[option] === true) {
                    oneChecked = true;
                }
            }
            allFalseArr.push(oneChecked)
        });
        if (allFalseArr.filter(item => item === false).length > 0) {
            setError("Bütün oyunlar üzrə proqnoz verilməlidir")
        } else {
            setIsLoading(true)
           try {
               const {data: id} = await axios.post(`voidTickets/createTicketByAgent`, group);
               const {data} = await axios.get(`tickets/byId`, {params: {id}});
               await dispatch(getProfile());
               dispatch(setPrintData(data));
               dispatch(setSnackbar({
                   variant: "success",
                   message: "Biletiniz uğurla yaradıldı!"
               }))
               setIsLoading(false);
               setShowBet(false);
               setShowPrint(true);
           } catch (err) {
               setIsLoading(false);
               setError(err?.response?.data?.message);
               const message = err.response?.data?.message;
               dispatch(setSnackbar({
                   variant: "error",
                   message
               }))
           }
        }
    }

    function calculateTotalAmount(games = []) {
        let choiceCounts = [];

        games.forEach(game => {
            let count = 0
            for (let key in game) {
                if (key === "gameId") continue;
                if (game[key] === true) {
                    count++
                }
            }
            if (count === 0) {
                count++
            }
            choiceCounts.push(count)
        });

        const totalAmount = choiceCounts.reduce((previousValue, currentValue) => previousValue * currentValue, 1) * columnPrice;
        setTotalAmount(totalAmount)
    }

    useEffect(() => {
        setIsLoading(true)
        onCirculationChoose(id)
            .then(({data: {columnPrice, games}}) => {
                setCirculationGames(games);
                setColumnPrice(columnPrice)
                const arr = games.map((game) => (
                    {
                        gameId: game.id,
                        option1: false,
                        optionX: false,
                        option2: false
                    }
                ));
                setInitialState(arr);
                setIsLoading(false);

            })
            .catch(() => {
                setIsLoading(false)
            })
    }, [])

    useEffect(() => {
        calculateTotalAmount(initialState)
    }, [initialState, columnPrice])

    return (
        <>
            <Modal
                size="md"
                show={show}
                onHide={onHide}
                aria-labelledby="create"
                centered
                className="modal pr-0"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="create">Mərc et</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <div className="col-12 pl-4 pr-4">
                            <RenderIf condition={isLoading}>
                                <div className={classes.progresRoot}>
                                    <CircularProgress className={classes.progress}/>
                                </div>
                            </RenderIf>
                            <RenderIf condition={!isLoading}>
                                <div className="row">
                                    {circulationGames.map((game, index) => (
                                        <div key={index} className={`col-12 col-md-12 col-lg-12 ${classes.col}`}>
                                            <div className="w-100 pt-2 pb-3 d-flex justify-content-between">
                                                <div
                                                    className="d-flex align-items-center">{index + 1}. {game.hostClubName} - {game.guestClubName}</div>
                                                <div className="d-flex justify-content-between">
                                                    <div>
                                                        <span>1</span>
                                                        <Checkbox
                                                            onChange={(e) => handleChange(e, index, "option1")}
                                                            value={initialState[index]?.option1}
                                                        />
                                                    </div>
                                                    <div>
                                                        <span>x</span>
                                                        <Checkbox
                                                            onChange={(e) => handleChange(e, index, "optionX")}
                                                            value={initialState[index]?.optionX}
                                                        />
                                                    </div>
                                                    <div>
                                                        <span>2</span>
                                                        <Checkbox
                                                            onChange={(e) => handleChange(e, index, "option2")}
                                                            value={initialState[index]?.option2}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="col-12 col-md-12 col-lg-12 d-flex justify-content-center">
                                        <span>Cəmi mərc məbləği: <b>{totalAmount}</b> AZN</span>
                                    </div>
                                    <div className="col-12 col-md-12 col-lg-12 d-flex justify-content-center">
                                        <span className="text-danger">{error}</span>
                                    </div>
                                </div>
                            </RenderIf>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="submit">Yarat</Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
};

export default connect(null, play.actions)(CreateVoidTicket)